module.exports = __webpack_public_path__ + "img/fastplay_left.c5e196cc.png";